import { getCartToken } from "@faire/add-to-cart/serialized-data/getCartToken";
import { useInvalidateQuery as useInvalidateCartQuery } from "@faire/web-api--source/endpoints/www/api/v2/carts/cartToken/get-hooks";
import { useCallback } from "react";

import { useBrandCartQueryParams } from "./useBrandCartQueryParams";

export const useInvalidateBrandCart = () => {
  const buildQueryParams = useBrandCartQueryParams();
  const invalidateCartQuery = useInvalidateCartQuery();

  const invalidateCartRequest = useCallback(
    async ({ brandToken }: { brandToken: string }) => {
      const args = [
        getCartToken(),
        buildQueryParams({ brandToken }),
        undefined,
        { refetchType: "all" },
      ] as const;
      await Promise.all([invalidateCartQuery(...args)]);
    },
    [buildQueryParams, invalidateCartQuery]
  );

  const invalidateBrandCart = useCallback(
    async ({ brandToken }: { brandToken: string }) => {
      const promises: Promise<void>[] = [];
      promises.push(invalidateCartRequest({ brandToken }));
      await Promise.all(promises);
    },
    [invalidateCartRequest]
  );

  return {
    invalidateBrandCart,
  };
};
